import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";

let permissoesCache = null;
let requisicaoEmAndamento = null;

const aguardar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const obterUsuarioLogado = async () => {
  for (let tentativa = 0; tentativa < 6; tentativa++) {
    const usuario = sso.getUsuarioLogado();
    if (usuario?.id) return usuario;
    await aguardar(100 * (tentativa + 1));
  }
  return null;
};

export const getPermissao = async () => {
  if (permissoesCache) return permissoesCache;
  if (requisicaoEmAndamento) return requisicaoEmAndamento;

  requisicaoEmAndamento = (async () => {
    try {
      const usuarioLogado = await obterUsuarioLogado();
      if (!usuarioLogado?.id) return [];

      const response = await api.get(`usuario/${usuarioLogado.id}/funcionalidades`);
      const funcionalidades = response.data?.funcionalidade_id ?? [];
      const permissoes = funcionalidades.map((id) => Number(id));

      permissoesCache = permissoes;
      return permissoes;
    } catch (error) {
      console.error("Erro ao obter permissões", error);
      return [];
    } finally {
      requisicaoEmAndamento = null;
    }
  })();

  return requisicaoEmAndamento;
};
